import { searchProducts } from "@ludens-reklame/rubics-v3-sdk/product";
import { useSearch } from "../search/search.hooks.js";
export function useProductSearch(init = {}, query = {}) {
    query.faceted = typeof query.faceted === "boolean" ? query.faceted : true;
    return useSearch(searchProducts, init, query);
}
